import { Component } from '@angular/core';
import { PROVIDER_COLUMNS } from "@modules/private/provider/data/constants/provider.constants";
import { ApiProviderService } from "@modules/private/provider/data/services/api/api-provider.service";
import { MessageService } from "primeng/api";
import { ACTIONS } from "../data/constants/provider.constants";
import { ProviderService } from '../data/services/view/provider.service';

@Component({
  selector: 'app-provider-list',
  templateUrl: './provider-list.component.html',
  styleUrls: ['./provider-list.component.scss'],
  providers: [MessageService]
})
export class ProviderListComponent {
  columns = PROVIDER_COLUMNS
  createEntity = false
  action = 'CREATE'
  additionalMainActions = [{ label: 'Nuevo proveedor', icon: 'fa-solid fa-square-plus', action: 'CREATE', permission: ['providers', 'create'] as [string, string] }]
  actions = ACTIONS
  loading = true
  page = 1;
  limit = 10;
  filters = {};

  constructor(
    public apiProviderService: ApiProviderService,
    public messageService: MessageService,
    public providerService: ProviderService
  ) {
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;
  }

  hideDialog() {
    this.createEntity = false;
  }

  mainActions(flow: string) {
    switch (flow) {
      case 'CREATE':
        this.providerService.newEntity()
        this.providerService.entity.reset()
        this.createEntity = true
        break;
      default:
        console.log(flow)
        break;
    }
  }

  actionMethods(data: { event: any, action: string, data: any }) {
    switch (data.action) {
      case 'EDIT':
        this.providerService.formMethod = 'EDIT'
        this.providerService.provider = data.data
        this.providerService.newEntity()
        this.createEntity = true
        break;
    }
  }

  handleError(error: any) {
    if (error.status === 400 && error.error.data?.errors) {
      const errors = error.error.data.errors;
      errors.forEach((err: any) => {
        this.showErrorMessage(err.msg || 'Por favor revise que los campos estén correctos.');
      });
    } else {
      this.showErrorMessage('Ocurrió un error inesperado al crear el activo.');
    }
  }

  showErrorMessage(message: string) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }

  showSuccessMessage(message: string) {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: message });
  }

  getErrorMessage(errorKey: string, errorValue: any): string {
    const errorMessages: any = {
      required: 'Este campo es obligatorio.',
      minlength: `El valor ingresado es muy corto. Mínimo ${errorValue.requiredLength} caracteres.`,
      negativeValue: 'El valor no puede ser negativo.',
      onlyLetters: 'Solo se permiten letras.',
    };

    return errorMessages[errorKey] || 'Error en la validación de los datos.'
  }

  showFormErrors() {
    Object.keys(this.providerService.entity.controls).forEach((key) => {
      const controlErrors = this.providerService.entity.get(key)?.errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach((errorKey) => {
          this.showErrorMessage(`Error en el campo ${key}: ${this.getErrorMessage(errorKey, controlErrors[errorKey])}`);
        });
      }
    });
  }

  saveForm() {
    if (this.providerService.entity.invalid) {
      this.providerService.entity.markAllAsTouched();
      this.showFormErrors();
      return;
    }

    if (this.providerService.formMethod === 'CREATE') {
      const data = this.providerService.entity.value;
      this.apiProviderService.create(data).subscribe(
        (response) => {
          this.loadData();
          this.hideDialog();
          this.showSuccessMessage('El activo fue creado exitosamente.');
        },
        (error) => {
          this.handleError(error);
        }
      );
    } else if (this.providerService.formMethod === 'EDIT') {
      const data = this.providerService.entity.value;
      this.apiProviderService.update(this.providerService.provider._id, data).subscribe(
        (response) => {
          this.hideDialog();
          this.showSuccessMessage(`El activo ${this.providerService.provider.name} fue actualizado exitosamente.`);
          this.loadData();
        },
        (error) => {
          this.handleError(error);
        }
      );
    }
  }

  onPageChange(event: any) {
    this.page = event.page + 1;
    this.limit = event.rows;
    this.loadData();
  }

  onFilterChange(event: any) {
    this.filters = event.filters;
    this.loadData();
  }
}
